import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { FiCheckCircle } from "react-icons/fi";
import SectionHeading from "../../components/SectionHeading";
import { homeIcons } from "../Home/homeIcons";
import { combinedExpertiseContent as expertiseContent } from "./teamContent";

/* "Our Combined Expertise" — the document's four areas, each with its own
   lead-in label ("Supporting organizations with:" / "Supporting:"). */

const cardVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.45, ease: "easeOut" } },
};

const TeamExpertise = () => (
  <section
    className="bg-gray-50 py-14 lg:py-20"
    aria-labelledby="team-expertise-heading"
  >
    <div className="brand-col">
      <SectionHeading
        id="team-expertise-heading"
        title={expertiseContent.title}
        subtitle={expertiseContent.subtitle}
      />
      <p className="mx-auto -mt-4 mb-10 max-w-3xl text-center text-sm md:text-base leading-relaxed text-gray-600">
        {expertiseContent.intro}
      </p>
      <motion.ul
        className="grid list-none grid-cols-1 gap-6 p-0 lg:grid-cols-2 lg:gap-8"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.1 }}
        variants={{ visible: { transition: { staggerChildren: 0.08 } } }}
      >
        {expertiseContent.areas.map((area) => {
          const Icon = homeIcons[area.icon];
          return (
            <motion.li
              key={area.title}
              variants={cardVariants}
              className="brand-card"
            >
              <Link
                to={area.to}
                className="block h-full p-6 lg:p-8 rounded-[inherit] text-inherit hover:text-inherit focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--brand-orange)]"
              >
                <div className="flex items-center gap-4">
                  <span className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-xl bg-[var(--brand-primary)] text-white shadow-md">
                    <Icon aria-hidden="true" className="h-5 w-5" />
                  </span>
                  <h3 className="text-lg lg:text-xl font-bold text-gray-900">
                    {area.title}
                  </h3>
                </div>
                {area.description && (
                  <p className="mt-5 text-sm md:text-base leading-relaxed text-gray-600">
                    {area.description}
                  </p>
                )}
                <p className="mt-5 text-sm font-semibold text-gray-900">
                  {area.itemsLabel}
                </p>
                <ul className="mt-3 grid grid-cols-1 gap-x-6 gap-y-2 sm:grid-cols-2">
                  {area.items.map((item) => (
                    <li key={item} className="flex items-start gap-3">
                      <FiCheckCircle
                        aria-hidden="true"
                        size={18}
                        className="mt-0.5 flex-shrink-0 text-[var(--brand-primary)]"
                      />
                      <span className="text-sm md:text-base text-gray-700">
                        {item}
                      </span>
                    </li>
                  ))}
                </ul>
              </Link>
            </motion.li>
          );
        })}
      </motion.ul>
    </div>
  </section>
);

export default TeamExpertise;
